import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { postRequest } from '../../services/api/apiRequest';
import * as userService from '../../services/userService';
import auth from '../../services/authService';

export default function SignUpForm(props) {
  const [apiError, setApiError] = useState(null);

  const handleSubmit = (event) => {
    setApiError(null);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    handleSignUp(data);
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
  };

  const handleSignUp = async (data) => {
    console.log('handleRegister', data);
    const signUpBody = {
      username: data.get('email'),
      email: data.get('email'),
      password: data.get('password'),
      roles: ['user'],
    };
    try {
      const response = await userService.register(signUpBody);
      //auth.loginWithJwt(response.headers['x-access-token']);
      window.location = '/login';
    } catch (ex) {
      if (ex.response && ex.response.status >= 400) {
        setApiError(ex.response.data.message);
      }
    }
  };

  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component='h1' variant='h5'>
        Sign up
      </Typography>
      <Box component='form' noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          {apiError && (
            <Grid item xs={12}>
              <Alert severity="error">{apiError}</Alert>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField autoComplete='given-name' name='username' required fullWidth id='username' label='Name' autoFocus />
          </Grid>
          <Grid item xs={12}>
            <TextField required fullWidth id='email' label='Email Address' name='email' autoComplete='email' />
          </Grid>
          <Grid item xs={12}>
            <TextField required fullWidth name='password' label='Password' type='password' id='password' autoComplete='new-password' />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel control={<Checkbox value='allowExtraEmails' color='primary' />} label='I want to receive inspiration, marketing promotions and updates via email.' />
          </Grid>
        </Grid>
        <Button type='submit' fullWidth variant='contained' sx={{ mt: 3, mb: 2 }}>
          Sign Up
        </Button>
        <Grid container justifyContent='flex-end'>
          <Grid item>
            <Link href='login' variant='body2'>
              Already have an account? Sign in
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
